// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l_M-","toggleWrap":"styles_toggleWrap__3Kkb4","content":"styles_content__2vgQp","selectAreaCode":"styles_selectAreaCode__3qESR"};